import { Request } from '@/classes/Request'

/**
 * Invalidate the enrollment Quickpay cart so the family can go back and edit
 * their form. After cancelling, reloading the enrollment iframe re-resolves to
 * the form (not payment); re-submitting mints a fresh cart for the updated
 * answers. Token-authenticated, no session.
 * POST /api/enrollment/invitation/{token}/quickpay/{guid}/cancel
 */
export const enrollmentCancelCart = async (token: string, guid: string): Promise<any> => {
  const response = await new Request().post(
    `/api/enrollment/invitation/${encodeURIComponent(token)}/quickpay/${encodeURIComponent(
      guid
    )}/cancel`,
    {}
  )
  return response.data
}
